import { TIME_ZONE } from "../constants";
import { Dayjs, dayjs } from "../Date/DateUtil";

export const compareTwoDateWithoutTimestamp = (
  fromDate: any,
  endDate: any
): Boolean =>
  fromDate && endDate ? dayjs(fromDate).isAfter(endDate, "day") : false;

/**
 * Get date and time by predefined time zone and in iso string format
 * Pass no parameters to get a new date and time
 * @param {string | Date | any} dateTime - Convert an existing date and time by passing dateTime
 * @param dateOffset - Add days by passing dateOffset
 */
export const getDateTimeByTimezoneInISOStringFormat = (
  dateTime?: string | Date | Dayjs | null,
  dateOffset?: number,
  timeZone?: string
): string => {
  const newDateTime: Dayjs = dateTime ? dayjs(dateTime) : dayjs();
  return dateOffset ? newDateTime.add(dayjs.duration({'days' : dateOffset})).format("YYYY-MM-DDTHH:mm:ss.SSSZ") : newDateTime.tz(TIME_ZONE).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
};